import AdvicesBlock from "./AdvicesBlock/AdvicesBlock";
import EntryBlock from "./EntryBlock/EntryBlock";
import FeaturesBlock from "./FeaturesBlock/FeaturesBlock";
import TutorialBlock from "./TutorialBlock/TutorialBlock";
import VideoUpload from "../videoUpload";
import BoldMenu from "../BoldMenu/BoldMenu";
import UploadProgress from "../ProgressBar/UploadProgress";
import MainBlob from "../../animate/MainBlob";
import TryOurTools from "../../tryOurTools/tryOurTools";
import UploadYourFile from "../../tryAITool/tryAITool";
import FaqComponent from "../../FaqComponent/FaqComponent";
import { MemoizedReviews } from "../../main_page/UserReviews/UserReviews";

export { AdvicesBlock, EntryBlock, FeaturesBlock, TutorialBlock, VideoUpload, BoldMenu, UploadProgress, MainBlob, TryOurTools, UploadYourFile, FaqComponent, MemoizedReviews }